import { areReservationsNotificationsEnabled } from '@data/store/FeatureFlagsProvider';
import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported, Messaging } from 'firebase/messaging';
import { logger } from './errors';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseio.com`,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let messaging: Messaging | undefined;

export const NOTIFICATION_NOT_SUPPORTED_LOG_KEY = 'notification_not_supported';

if (areReservationsNotificationsEnabled()) {
  isSupported()
    .then((supported) => {
      if (supported) {
        initializeApp(firebaseConfig);
        messaging = getMessaging();
      } else {
        logger.errorOnce(
          'Browser does not support notifications',
          NOTIFICATION_NOT_SUPPORTED_LOG_KEY
        );
      }
    })
    .catch(() => {
      logger.errorOnce(
        'Browser does not support notifications',
        NOTIFICATION_NOT_SUPPORTED_LOG_KEY
      );
    });
}

export const getFirebaseMessaging = () => {
  return messaging;
};
